import React from 'react';
import Moment from 'moment-timezone';
import Handlebars from 'handlebars';
import { DEFAULT_SERVICE_NAME } from '../../../utils/consts'

import { Card, Stack, TextField, TextStyle, TextContainer} from '@shopify/polaris';
import './index.css';
import { DEFAULT_HOST_REQUEST_NOTE } from '../../../utils/consts';

export function Preview( {locale, templateData, customData, shopData, serviceData, userData}) {

    const hello = Handlebars.compile(templateData.text.hello);
    const confirmation = Handlebars.compile(templateData.text.confirmation);
    const changeInstructionsTemplate = Handlebars.compile(templateData.text.change_instructions);
    const serviceNoun = (serviceData && serviceData.serviceNoun && serviceData.serviceNoun[locale]) || DEFAULT_SERVICE_NAME[locale];
    const formattedTimestamp = Moment().tz(shopData.ianaTimezone).locale(locale).format('LLLL (z)');

    const salutation = customData?.salutation ? Handlebars.compile(customData?.salutation) : null;
    return (
        <Card.Section>
            <Stack vertical spacing='loose'>
                <br />
                <p className='custom-text-preview' dangerouslySetInnerHTML={{ __html: hello({ clientName: userData?.firstName ?? 'Client' }) }} />
                <TextContainer spacing='tight'>
                    <p className='custom-text-preview' dangerouslySetInnerHTML={{ __html: confirmation({ shopName: shopData.name, serviceNoun, formattedTimestamp }) }} />
                </TextContainer>                
                <TextContainer spacing='tight'>
                <p className='custom-text-preview' dangerouslySetInnerHTML={{ __html: changeInstructionsTemplate({ change_link_text: templateData.text.change_link_text }) }} />
                </TextContainer>
                <TextContainer spacing='tight'>
                    <p className='personal-note'>{DEFAULT_HOST_REQUEST_NOTE[locale]}</p>
                </TextContainer>
                {salutation && <p className='custom-text-preview' dangerouslySetInnerHTML={{ __html: salutation({shopName: shopData.name}) }} />}
                <p className='email-footer'>{templateData.text.footer}</p>
            </Stack>
        </Card.Section>
    )

}

export function Customize({ customData, onChange, OnError }) {

    //const handleCustomTextChange = (val) => onChange({...customData, customText: val || null });
    const handleSalutationChange = (val) => onChange({...customData, salutation: val || null });


    //const customText = customData && customData.customText;
    const salutation = customData && customData.salutation;

    return (
        <>
        {/* <Card.Section title='Custom message'>
                <TextField value={customText} onChange={handleCustomTextChange} multiline={6} />
        </Card.Section> */}
        <Card.Section title='Salutation'>
                <TextField value={salutation} onChange={handleSalutationChange} multiline={3} />
        </Card.Section>
        </>


    )
}